import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import './Footer.css';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__main">
          {/* Brand */}
          <div className="footer__brand">
            <h3 className="footer__brand-name">
              Cabana <span>Buru</span>
            </h3>
            <p className="footer__brand-tagline">{t('footer.brand.tagline')}</p>
            <p className="footer__brand-desc">
              {t('footer.brand.desc')}
            </p>
          </div>

          {/* Navigation */}
          <div className="footer__col">
            <h4 className="footer__col-title">{t('footer.navigate.title')}</h4>
            <ul className="footer__links">
              <li><Link to="/">{t('footer.navigate.home')}</Link></li>
              <li><Link to="/gallery">{t('footer.navigate.gallery')}</Link></li>
              <li><Link to="/rent">{t('footer.navigate.book')}</Link></li>
              <li><Link to="/reviews">{t('footer.navigate.reviews')}</Link></li>
              <li><Link to="/contact">{t('footer.navigate.contact')}</Link></li>
            </ul>
          </div>

          {/* Experience */}
          <div className="footer__col">
            <h4 className="footer__col-title">{t('footer.experience.title')}</h4>
            <ul className="footer__links">
              <li><Link to="/gallery">{t('footer.experience.views')}</Link></li>
              <li><Link to="/gallery">{t('footer.experience.trails')}</Link></li>
              <li><Link to="/gallery">{t('footer.experience.cuisine')}</Link></li>
              <li><Link to="/gallery">{t('footer.experience.stargazing')}</Link></li>
            </ul>
          </div>

          {/* Account */}
          <div className="footer__col">
            <h4 className="footer__col-title">{t('footer.guest.title')}</h4>
            <ul className="footer__links">
              <li><Link to="/login">{t('footer.guest.signIn')}</Link></li>
              <li><Link to="/register">{t('footer.guest.register')}</Link></li>
              <li><Link to="/account">{t('footer.guest.account')}</Link></li>
              <li><Link to="/reviews">{t('footer.guest.writeReview')}</Link></li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="footer__divider">
          <span className="footer__divider-line" />
          <span className="footer__divider-diamond" />
          <span className="footer__divider-line" />
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <div className="footer__flag">
          <span /><span /><span />
        </div>
        <p className="footer__copy">{t('footer.bottom.rights')}</p>
        <p className="footer__made">
          {t('footer.bottom.madeWith')} <span className="footer__made-heart">&#9829;</span> in Romania
        </p>
      </div>
    </footer>
  );
}
